export default __webpack_public_path__ + "assets/images/845fb6d5d3075afebbf0d2c8fd5f1911.png";